import { QueryCache } from 'react-query';

export const portalQueryCache = new QueryCache({
  defaultConfig: {
    queries: { refetchOnWindowFocus: false, refetchInterval: false, retry: false },
  },
});
